import { addCollapsibleListeners } from "./modules/collapse";
// import flatpickr from "flatpickr";
// require("flatpickr/dist/themes/light.css");

export function bbqPage() {
    // flatpickr("#afhaal_datum", {
    //   dateFormat: "Y-m-d",
    //   minDate: new Date().fp_incr(2),
    //   defaultDate: new Date(),
    // });

    // flatpickr("#bezorg_datum", {
    //   dateFormat: "Y-m-d",
    //   minDate: new Date().fp_incr(2),
    //   defaultDate: new Date(),
    // });

    [...document.querySelectorAll('[data-group="bbq-collapsibles"]')].forEach((element) => {
        addCollapsibleListeners(
            element,
            function (collapsible, toggle) {
                const selector = collapsible.id.replace(" ", "_");
                // Get toggles and animate
                [...document.querySelectorAll("." + selector + "-toggle")].forEach((toggle) => {
                    // prevent mobile button from expanding
                    if (toggle.classList.contains("h-150")) {
                        toggle.classList.add("h-300");
                    }
                });
                [...document.querySelectorAll("." + selector + "-close")].forEach((close) => {
                    close.classList.remove("opacity-0");
                });
            },
            function (collapsible, toggle) {
                const selector = collapsible.id.replace(" ", "_");
                [...document.querySelectorAll("." + selector + "-toggle")].forEach((toggle) => {
                    // prevent mobile button from expanding
                    if (toggle.classList.contains("h-150")) {
                        toggle.classList.remove("h-300");
                    }
                });
                [...document.querySelectorAll("." + selector + "-close")].forEach((close) => {
                    close.classList.add("opacity-0");
                });
            },
            false,
        );
    });

    [...document.querySelectorAll('[id ^= "product-quantity-"]')].forEach((input) => {
        const productID = input.id.replace("product-quantity-", "");

        document.getElementById(productID + "-minus").addEventListener("click", () => {
            input.value = Math.max(0, parseInt(input.value) - 1);
            updatePrice();
        });

        document.getElementById(productID + "-plus").addEventListener("click", () => {
            input.value = parseInt(input.value) + 1;
            updatePrice();
        });
    });
    updatePrice();
}

function updatePrice() {
    let total = 0;
    [...document.querySelectorAll('[id ^= "product-quantity-"]')].forEach((input) => {
        total += input.value * input.dataset.price;
    });

    let discount = calculateDiscount();

    const price = document.getElementById("totalPrice");
    if (price) {
        price.innerHTML = (total - discount).toFixed(2);
    }
}

function calculateDiscount() {
    // GEt array of all the prices which could be discounted
    let kiesArray = [];
    [...document.querySelectorAll('[id ^= "product-quantity-"]')].forEach((input) => {
        if (input.dataset.kies == "true" && input.value > 0) {
            for (let index = 0; index < input.value; index++) {
                kiesArray.push(input.dataset.price);
            }
        }
    });
    // Sort them largest first
    kiesArray.sort().reverse();
    // Get number of discounted items
    let numberOfDiscounts = Math.floor(kiesArray.length / 4) * 4;
    // Calculate and add up, the difference between the real price and 10 / 4 foreach discounted item
    let discount = 0;
    for (let index = 0; index < numberOfDiscounts; index++) {
        discount += kiesArray[index] - 2.5;
    }
    return discount;
}
